import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { idealistRequireAuthentication } from '#/modules/auth/routing/idealist-require-authentication';
import type { orgDashboardMembershipLinksRoute } from '#/modules/orgDashboard/routing/org-select.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { MembershipLinksLoadable } from './MembershipLinksLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof orgDashboardMembershipLinksRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    MembershipLinksLoadable.load(),
  ]);

  if (!user) return idealistRequireAuthentication({ request, context });
}

export default function OrgDashboardMembershipLinksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: page to choose organization to see membership page */
        i18n('Membership')
      }
    >
      <MembershipLinksLoadable />
    </RouteModule>
  );
}
